import { create } from 'zustand';

interface PhotoStore {
	photo: string | null;
	make: (val: string) => void;
	clear: () => void;
}

export const photoStore = create<PhotoStore>(set => ({
	photo: null,
	make: (val: string) => set(old => ({ ...old, photo: val })),
	clear: () => set(old => ({ ...old, photo: null })),
}));
